import script from "./Phone_List_Dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Phone_List_Dialog.vue?vue&type=script&setup=true&lang=js"

import "./Phone_List_Dialog.vue?vue&type=style&index=0&id=0fdcb04b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fdcb04b"]])

export default __exports__